import { showToast } from 'vant'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { decrypt, encrypt } from '@/utils/decryptQrc'
import useClickId from './useClickId'

const useQrCode = () => {
  const store = useStore()
  const router = useRouter()
  const userInfo = computed(() => store.state.userInfo)
  const commonDsl = computed(() => store.state.dslData.commonDsl)
  const peerInfo = computed(() => store.state.peerInfo)
  const { bid } = useClickId()

  const qrcodeUrl = ref('')
  const acquisitionLinkUrl = ref('')

  const fetchQrcode = async (inputBid, isPeer) => {
    const {
      code,
      data: resData,
      message,
    } = await store.dispatch(
      userInfo.value.unionid && !isPeer
        ? 'getCommonResourceQrcode'
        : 'getQrcodeWithoutBid',
      userInfo.value.unionid && !isPeer
        ? {
            groupId: encrypt(bid.value),
            unionId: userInfo.value.unionid,
          }
        : { bid: inputBid || bid.value }
    )
    if (code === 1) {
      qrcodeUrl.value = resData.imageUrl ? decrypt(resData.imageUrl) : ''
      acquisitionLinkUrl.value = resData.acquisitionLinkUrl ? decrypt(resData.acquisitionLinkUrl) : ''
    } else showToast(message || '二维码获取失败')
  }

  const fetchSamePeerStatus = async () => {
    // 如果选择了防同行并且unionid存在的话 那么就请求接口并向本地存储中保存同行状态
    if (userInfo.value.unionid) {
      await store.dispatch('getPeerStatus', {
        unionId: userInfo.value.unionid,
        groupId: bid.value,
      })
      // 如果是同行 就跳转到预设好的同行固定页
      if (peerInfo.value.isPeers) {
        router.push({
          path: `/peerPage/${new Date().getTime()}`,
          query: {
            pageCode: commonDsl.value?.peerPosition || 'tonghang_page'
          }
        })
        // window.location.href = commonDsl.value.samePeerPageUrl || ''
      }
    }
  }

  return {
    fetchQrcode,
    qrcodeUrl,
    acquisitionLinkUrl,
    fetchSamePeerStatus,
  }
}

export default useQrCode
